import axiosInstance from './api';

export const loginUser  = async (email, password) => {
  const payload = {
    user: {
      email,
      password,
    },
  };

  let axiosConfig = {
    headers: {
      'Access-Control-Allow-Origin': '*', 
      'Content-Type': 'application/json'
  }
  };

  try {
    const response = await axiosInstance.post('/api/v1/login', payload , axiosConfig);
    const token = response.headers['authorization'] || response.headers['Authorization'] || response.data?.token;
    if (!token) {
      throw new Error('Token not found in response headers or body');
    }

    const body = response.data || {};
    const apiUser = body.user || body.data || body;
    const emailFromApi = apiUser.email || email;
    const first_name =
      apiUser.first_name || apiUser.firstName || apiUser.firstname || "";
    const last_name =
      apiUser.last_name || apiUser.lastName || apiUser.lastname || "";

    let agentIntegrationsToStore = {};

    if (body?.public_agent_integrations?.agent_integrations) {
      agentIntegrationsToStore = {
        ...body.public_agent_integrations.agent_integrations,
      };
    }
    if (apiUser?.public_agent_integrations?.agent_integrations) {
      agentIntegrationsToStore = {
        ...agentIntegrationsToStore,
        ...apiUser.public_agent_integrations.agent_integrations,
      };
    }
    if (body?.agent_integrations && Object.keys(body.agent_integrations).length > 0) {
      agentIntegrationsToStore = {
        ...agentIntegrationsToStore,
        ...body.agent_integrations,
      };
    }
    if (
      apiUser?.agent_integrations &&
      Object.keys(apiUser.agent_integrations).length > 0
    ) {
      agentIntegrationsToStore = {
        ...agentIntegrationsToStore,
        ...apiUser.agent_integrations,
      };
    }

    if (Object.keys(agentIntegrationsToStore).length > 0) {
      localStorage.setItem(
        "agent_integrations",
        JSON.stringify(agentIntegrationsToStore)
      );
    }

    if (apiUser.id != null && apiUser.id !== "") {
      localStorage.setItem("user_id", String(apiUser.id));
    }

    const chatAgent =
      agentIntegrationsToStore.chat_agent ||
      agentIntegrationsToStore.Chat_agent ||
      agentIntegrationsToStore.brainstorm_chat_agent ||
      null;

    console.log("[Productive] Login API success", {
      email: emailFromApi,
      userId: apiUser.id ?? null,
      hasToken: Boolean(token),
      agentIntegrationsKeys: Object.keys(agentIntegrationsToStore),
      chatAgent: chatAgent ? "(set)" : "(missing)",
      dim3Folder: agentIntegrationsToStore.knowledge_base_dim3_folder_id
        ? "(set)"
        : "(missing)",
      apiBaseUrl: process.env.REACT_APP_API_BASE_URL || "(default)",
    });

    return {
      token,
      user: {
        email: emailFromApi,
        id: apiUser.id,
        api_key: apiUser.api_key,
        first_name,
        last_name,
      },
    };
  } catch (error) {
    throw new Error(error.response?.data?.message || error.response?.data?.error || 'Login failed');
  }
};